import React from 'react';
import { AVAILABLE_FONTS } from '../utils/fonts';
import './FontSelector.css';

const FontSelector = ({ selectedFont, onFontChange }) => {
  return (
    <div className="font-selector">
      <label className="font-selector-label">フォント</label>
      <div className="font-options">
        {AVAILABLE_FONTS.map(font => (
          <div key={font.id} className="font-option">
            <input
              type="radio"
              id={`font-${font.id}`}
              name="font"
              value={font.id}
              checked={selectedFont === font.id}
              onChange={() => onFontChange(font.id)}
              className="font-radio"
            />
            <label 
              htmlFor={`font-${font.id}`} 
              className="font-label"
              style={{ fontFamily: font.fontFamily }}
            >
              <span className="font-preview" style={{ fontFamily: font.fontFamily }}>
                願いごと
              </span>
              <span className="font-name">{font.displayName}</span>
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FontSelector;